ixModuleRouting("impactx.login", {
    "/login": {
        template: "<ixa-login></ixa-login>",
        templateUrl: "modules/login/templates/login.html",
        controller: "LoginController",
        controllerAs: "loginCtrl",
        noSecurity: true,
    },
    "/login/register": {
        template: "<ixa-login></ixa-login>",
        templateUrl: "modules/login/templates/login.html",
        controller: "LoginController",
        controllerAs: "loginCtrl",
        noSecurity: true,
    },
    "/loginopenid/:osuTan?": {
        template: "<ixa-login-open-id></ixa-login-open-id>",
        templateUrl: "modules/login/templates/login.html",
        controller: "LoginOpenIdCtrl",
        controllerAs: "loginOpenIdCtrl",
        noSecurity: true,
    },
    "/logoutopenid": {
        template: "<ixa-logout-open-id></ixa-logout-open-id>",
        templateUrl: "modules/login/templates/empty.html",
        controller: "LogoutOpenIdCtrl",
        controllerAs: "logoutOpenIdCtrl",
        noSecurity: true,
    },
    "/openidstartpage/:token": {
        template: "<ixa-open-id-startpage></ixa-open-id-startpage>",
        templateUrl: "modules/login/templates/login.html",
        controller: "OpenIdStartpageCtrl",
        controllerAs: "openIdStartpageCtrl",
        noSecurity: true,
    },
    "/login/error/:error/:errordescription": {
        template: "<ixa-login-error></ixa-login-error>",
        templateUrl: "modules/login/templates/login.error.html",
        controller: "LoginErrorCtrl",
        controllerAs: "loginErrorCtrl",
        noSecurity: true,
    },
    "/pwreset": {
        template: "<ixa-password-reset></ixa-password-reset>",
        templateUrl: "modules/login/templates/resetpw.page.html",
        controller: "PasswordResetController",
        controllerAs: "pwResetCtrl",
        process: "Auth",
    },
    "/logout": {
        template: "<ixa-direct-logout></ixa-direct-logout>",
        controller: "DirectLogoutController",
        controllerAs: "logoutCtrl",
    },
    "/custom/:value": {
        template: "<ixa-custom-login></ixa-custom-login>",
        templateUrl: "modules/login/templates/customlogin.html",
        controller: "CustomLoginCtrl",
        controllerAs: "customLoginCtrl",
        process: "Any",
    },
    "/custom/register/:value": {
        template: "<ixa-custom-login></ixa-custom-login>",
        templateUrl: "modules/login/templates/customlogin.html",
        controller: "CustomLoginCtrl",
        controllerAs: "customLoginCtrl",
        process: "Any",
        noSecurity: true
    },
    "/loginsaml/:token": {
        template: "<ixa-login-saml></ixa-login-saml>",
        templateUrl: "modules/login/templates/login.sso.html",
        controller: "LoginSamlCtrl",
        controllerAs: "loginCtrl",
        noSecurity: true,
    },
    "/loginsamlerror/:errors?": {
        templateUrl: "modules/login/templates/login.error.html",
        template: "<ixa-login-saml-error></ixa-login-saml-error>",
        controller: "LoginSamlErrorCtrl",
        controllerAs: "loginSamlErrorCtrl",
        workspace: "shop",
        noSecurity: true,
    },
    "/chooseexternallogin/:osuTan?": {
        template: "<ixa-login-choose-external></ixa-login-choose-external>",
        templateUrl: "modules/login/templates/login.chooseexternal.html",
        controller: "LoginChooseExternalCtrl",
        controllerAs: "loginChooseExternalCtrl",
        workspace: "shop",
        noSecurity: true,
    },
    "/selectexternallogin/:idPId/:osuTan?": {
        template: "<ixa-login-select-external></ixa-login-select-external>",
        templateUrl: "modules/login/templates/empty.html",
        controller: "LoginSelectExternalCtrl",
        controllerAs: "loginSelectExternalCtrl",
        workspace: "shop",
        noSecurity: true,
    },
    "/ocilogin/:token": {
        template: "<ixa-login-oci></ixa-login-oci>",
        templateUrl: "modules/login/templates/login.oci.html",
        controller: "LoginOciCtrl",
        controllerAs: "loginOciCtrl",
        noSecurity: true,
    },
    "/cxmllogin/:token": {
        template: "<ixa-login-cxml></ixa-login-cxml>",
        templateUrl: "modules/login/templates/login.cxml.html",
        controller: "LoginCXMLCtrl",
        controllerAs: "loginCXMLCtrl",
        noSecurity: true,
    },
    "/demo/:userId": {
        template: "<ixa-demo-user-login></ixa-demo-user-login>",
        controller: "DemoUserLoginCtrl",
        controllerAs: "demoUserloginCtrl",
        noSecurity: true,
    },
    "/copyccuser": {
        template: "<ixa-copy-cc-User></ixa-copy-cc-User>",
        templateUrl: "modules/login/templates/copyccuser.page.html",
        controller: "CopyCCUserController",
        controllerAs: "copyCCUserCtrl",
        process: "CopyCC",
    },
    "/s-login": {
        template: "<ixa-s-login></ixa-s-login>",
        templateUrl: "modules/login/templates/s-login.html",
        controller: "SLoginController",
        controllerAs: "loginCtrl",
        noSecurity: true,
    },
    "/s-custom/:value": {
        template: "<ixa-s-custom-login></ixa-s-custom-login>",
        templateUrl: "modules/login/templates/s-custom-login.html",
        controller: "SCustomLoginCtrl",
        controllerAs: "customLoginCtrl",
        noSecurity: true,
    },
},['ngRoute', 'impactx.cube']);
